import type { Category } from '@/domain/Category';
import type { PromotionCardDefinition } from '../config';

export function promotionCardIsInCollection(
  card: PromotionCardDefinition,
  category?: Category
): boolean {
  return card.categoryId === category?.id || card.categoryId === category?.code;
}
